export default __webpack_public_path__ + "static/media/pp-icon.f3da3daa.svg";